const catToggle = {
  filterBtn: document.getElementById('jsFilterBtn') as HTMLElement,
  filterWrap: document.getElementById('jsFilterWrap') as HTMLElement,
  prodWrap: document.getElementById('jsProductWrap') as HTMLElement,
  viewBtn: document.getElementById('jsChangeView') as HTMLElement,

  init() {
    this.toggleFilter();
    this.toggleView();
  },

  toggleFilter() {
    if (this.filterBtn) {
      this.filterBtn.addEventListener('click', () => {
        this.filterBtn.classList.toggle('activeClass');
        this.filterWrap.classList.toggle('activeClass');
        this.prodWrap.classList.toggle('activeClass');
      });
    }
  },

  toggleView() {
    if (this.viewBtn) {
      this.viewBtn.addEventListener('click', () => {
        this.prodWrap.classList.toggle('viewChanged');
        this.viewBtn.classList.toggle('activeClass');
        this.prodWrap.classList.remove('activeClass');
      });
    }
  },
};

export default catToggle;
